import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import type { DesignSnackFormBaseModel } from "@/components/features/snack/snack/_shared/model/use-create-snack-form-base-model/type";
import { SnackList_SnackListPage_Query } from "@/components/features/snack/snack/list/model/repository/query/use-snack-list-query/query";

import { SnackCreate_SnackPage_Mutation } from "./mutation";
import { viewModelToInput } from "../../../../../_shared/model/use-create-snack-form-base-model/converter/view-model-to-input";

export const useSnackCreateMutation = () => {
	const { mutationFunc } = useCustomMutation(SnackCreate_SnackPage_Mutation);

	const onUpdate = useCallback(
		async ({ viewModel }: { viewModel: DesignSnackFormBaseModel["ViewModel"] }) => {
			const input = viewModelToInput({ viewModel });

			return await mutationFunc({
				variables: {
					input,
				},
				refetchQueries: [
					{
						query: SnackList_SnackListPage_Query,
						variables: {
							hotelID: viewModel.hotelID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	return {
		onUpdate,
	};
};
